import styled, { css } from 'styled-components';

export const Mobile = css`
    .custom-faqs .MuiTabScrollButton-root.Mui-disabled {
        width: 40px;
    }
`;

export const Styled = styled.div`
    .custom-faqs {
        font-size: 14px;
        margin-bottom: 15px;

        .MuiTabPanel-root {
            padding: 0;
            animation: fadeIn 0.4s ease-in-out;
        }
        @keyframes fadeIn {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
        .MuiTabScrollButton-root.Mui-disabled {
            width: 0;
        }
        .MuiTabs-flexContainer {
            gap: 15px;
            margin-bottom: 15px;

            .MuiTab-root {
                padding: 13px;
                border-radius: 8px;
                min-height: 0;
                font-size: 14px;
                color: #303641;
                font-weight: 600;
                background-color: #fff;
                &.selected {
                    color: var(--mui-palette-primary-main);
                    box-shadow: 3px 3px 15px 0px rgba(0, 0, 0, 0.1);
                }
                svg {
                    width: 0.8em;
                    height: 0.8em;
                }
            }
        }
        .icon {
            background-color: var(--mui-palette-text-light);
            border-radius: 100%;
            color: var(--mui-palette-primary-main);
        }
        .MuiPaper-root {
            background-color: transparent;
        }

        .MuiAccordion-root {
            &:before {
                display: none;
            }
            .MuiIcon-root {
                background-color: #f0f4f9;
                border-radius: 100%;
                width: 24px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #0098c2;
            }
            .MuiAccordionDetails-root {
                font-size: 14px;
                color: #646a76;
                max-width: 650px;
            }
            .MuiAccordionSummary-content {
                font-size: 14px;
                color: #303641;
                &.Mui-expanded {
                    font-weight: 600;
                }
            }
        }
    }
    @media only screen and (max-width: 600px) {
        ${Mobile}
    }
`;
